import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import ReactDOM from 'react-dom';
import CopyToClipboard from 'react-copy-to-clipboard';
import {
  MenuItem, Button, Overlay, Tooltip, OverlayTrigger,
} from 'react-bootstrap';
import DateTimeDisplay from '../../../../components/date-time-display';

import styles from './styles.css';

function InnerPopover({ children, className, style }) {
  return (
    <div className={`${styles.menuPopover} ${className}`} style={style}>
      {children}
    </div>
  );
}
InnerPopover.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};
InnerPopover.defaultProps = {
  className: null,
  children: null,
  style: {},
};

class ActionRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      confirmed: false,
      confirmDisconnect: false,
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.getTarget = this.getTarget.bind(this);
    
    this.requestEdit = this.requestEdit.bind(this);
    this.requestInvite = this.requestInvite.bind(this);
    this.requestCopyInvitationLink = this.requestCopyInvitationLink.bind(this);
    this.requestDelete = this.requestDelete.bind(this);
    this.requestHijack = this.requestHijack.bind(this);
    this.requestDisconnect = this.requestDisconnect.bind(this);
    this.checkSyncPermissions = this.checkSyncPermissions.bind(this);
    this.requestSyncOwnerProfile = this.requestSyncOwnerProfile.bind(this);
  }

  getTarget() {
    return ReactDOM.findDOMNode(this.target);
  }

  handleToggle() {
    this.setState({ open: !this.state.open, confirmed: false });
  }

  requestEdit() {
    this.setState({ open: false });
    this.props.requestEdit(this.props.data);
  }

  checkSyncPermissions() {
    this.props.requestCheckUserPermission(this.props.data);
  }


  requestSyncOwnerProfile() {
    this.props.requestSyncOwnerProfile(this.props.data);
    this.setState({ open: false });
  }

  requestDisconnect() {
    if (!this.state.confirmDisconnect) {
      this.setState({ confirmDisconnect: true });
    } else {
      this.setState({ confirmDisconnect: false, open: false }, () => {
        this.props.requestDisconnect(this.props.data);
      });
    }
  }
  requestInvite() {
    this.setState({ open: false });
    this.props.requestInvite(this.props.data);
  }
  requestCopyInvitationLink() {
    this.setState({ open: false });
    this.props.requestCopyInvitationLink(this.props.data);
  }
  requestHijack() {
    this.setState({ open: false });
    this.props.requestHijack(this.props.data);
  }

  requestDelete() {
    if (!this.state.confirmed) {
      this.setState({ confirmed: true });
    } else {
      this.setState({ confirmed: false, open: false }, () => {
        this.props.requestDelete(this.props.data);
      });
    }
  }

  renderInner() {
    const {
      canEdit, updating, deleting, inviting, hijacking, copying,
      data, canDelete, canEmail, canInvite, canCopyInvitationLink, canHijack,
      canDisconnect, canCheckSyncPermission,
      canSyncOwnerProfile,
    } = this.props;
    const { confirmed, confirmDisconnect } = this.state;
    const user = data;

    if (!canEdit && !canInvite && !canEmail && !canCopyInvitationLink && !canDelete && !canHijack) {
      return null;
    }

    const disabled = updating || deleting || hijacking;

    const invited = user.last_invite_at !== null;
    let inviteLabel = invited ? 'Re-Send Invitation' : 'Send Invitation';

    const pendingInvite = data.pending_invite === true;

    if (pendingInvite) {
      inviteLabel = 'Processing Invitation Email';
    }
    const inviteIcon = inviting ? 'spinner' : 'envelope';

    const editLabel = updating ? 'Updating' : 'Edit';
    const editIcon = updating ? 'spinner' : 'edit';

    const deleteLabel = deleting ? 'Deleting' : 'Delete';
    const deleteIcon = deleting ? 'spinner' : 'trash';

    const disconnecting = updating;
    const disconnectLabel = disconnecting ? 'Disconnecting' : 'Disconnect';
    const disconnectIcon = disconnecting ? 'spinner' : 'power-off';

    const hijackLable = hijacking ? 'Hijacking' : `Login as ${(user.display_name || user.name)}`;
    const hijackIcon = hijacking ? 'spinner' : 'bolt';

    const copyLabel = copying ? 'Copied!' : 'Copy Invitation Link';

    let inviteComp = (<span><Fa name={inviteIcon} spin={inviting} /> {inviteLabel}</span>);
    if (invited) {
      const tip = (
        <Tooltip id={`invite-${user._id}`}>
          <div>
            Last invited: <DateTimeDisplay format="shortWithTime" value={user.last_invite_at} relative />
          </div>
        </Tooltip>
      );
      inviteComp = (
        <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}>
          {inviteComp}
        </OverlayTrigger>
      );
    }

    return (
      <div className="clearfix open">
        <ul className="dropdown-menu">
          <MenuItem header>{(user.display_name || user.name)}</MenuItem>
          {canEdit && <MenuItem disabled={disabled} onClick={this.requestEdit}><Fa name={editIcon} spin={updating} /> {editLabel}</MenuItem>}

          {canInvite &&
            <MenuItem disabled={(disabled || inviting || pendingInvite)} onClick={this.requestInvite}>
              {inviteComp}
            </MenuItem>
          }

          {canEmail && <li><a href={`mailto:${user.email}`}><Fa name="envelope" /> Send Email</a></li>}

          {canCopyInvitationLink &&
            <CopyToClipboard
              text={user.invite_url}
              disabled={(disabled || copying)}
              onCopy={() => { this.requestCopyInvitationLink(); }}
            >
              <MenuItem disabled={(disabled || copying)}><Fa name="clipboard" /> {copyLabel}</MenuItem>
            </CopyToClipboard>
          }

          {canHijack && <MenuItem disabled={disabled} onClick={this.requestHijack}><Fa name={hijackIcon} /> {hijackLable}</MenuItem>}
          

          {canCheckSyncPermission &&
            <MenuItem disabled={disabled} onClick={this.checkSyncPermissions}>
              <span><Fa name="check" /> Check Sync Permissions</span>
            </MenuItem>
          }

          {canSyncOwnerProfile && 
            <MenuItem disabled={disabled} onClick={this.requestSyncOwnerProfile}>
              <span><Fa name="refresh" /> Sync Owner Profile</span>
            </MenuItem>
          }

          {canDelete && <MenuItem divider />}

          {canDisconnect &&
            <MenuItem disabled={(disabled || inviting)} onClick={this.requestDisconnect}>
              {confirmDisconnect && <span className="text-danger"><Fa name="power-off" /> Are you sure?</span>}
              {!confirmDisconnect && <span><Fa name={disconnectIcon} spin={disconnecting} /> {disconnectLabel}</span>}
            </MenuItem>
          }

          {canDelete &&
            <MenuItem disabled={(disabled || inviting)} onClick={this.requestDelete}>
              {confirmed && <span className="text-danger"><Fa name="trash" /> Are you sure?</span>}
              {!confirmed && <span><Fa name={deleteIcon} spin={deleting} /> {deleteLabel}</span>}
            </MenuItem>
          }
        </ul>
      </div>
    );
  }

  render() {
    const {
      deleting, updating, inviting, hijacking,
    } = this.props;
    const disabled = deleting || updating;
    const { open } = this.state;

    const spin = updating || deleting || inviting;
    let label = 'Actions';
    if (updating) {
      label = 'Updating';
    } else if (deleting) {
      label = 'Deleting';
    } else if (inviting) {
      label = 'Inviting';
    } else if (hijacking) {
      label = 'Hijacking';
    }

    return (
      <div style={{ position: 'relative' }}>
        <Button
          disabled={disabled}
          ref={(target) => {
            this.target = target;
          }}
          bsStyle="primary"
          bsSize="xs"
          onClick={this.handleToggle}
        >
          {label} <Fa name={spin ? 'spinner' : 'caret-down'} spin={spin} />
        </Button>
        <Overlay
          show={open}
          rootClose
          onHide={() => this.setState({ open: false })}
          placement="bottom"
          target={this.getTarget}
        >
          <InnerPopover>
            {this.renderInner()}
          </InnerPopover>
        </Overlay>
      </div>
    );
  }
}

ActionRenderer.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    display_name: PropTypes.string,
    name: PropTypes.string,
    is_demo: PropTypes.bool,
    tru_voice_clients: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  deleting: PropTypes.bool,
  updating: PropTypes.bool,
  inviting: PropTypes.bool,
  hijacking: PropTypes.bool,
  copying: PropTypes.bool,
  canDisconnect: PropTypes.bool,

  canEdit: PropTypes.bool,
  canDelete: PropTypes.bool,
  canEmail: PropTypes.bool,
  canInvite: PropTypes.bool,
  canHijack: PropTypes.bool,
  canCopyInvitationLink: PropTypes.bool,

  requestEdit: PropTypes.func,
  requestInvite: PropTypes.func,
  requestCopyInvitationLink: PropTypes.func,
  requestDelete: PropTypes.func,
  requestHijack: PropTypes.func,
  requestDisconnect: PropTypes.func,

  canCheckSyncPermission: PropTypes.bool,
  requestCheckUserPermission: PropTypes.func,

  canSyncOwnerProfile: PropTypes.bool,
  requestSyncOwnerProfile: PropTypes.func,
};
ActionRenderer.defaultProps = {
  data: null,
  deleting: false,
  updating: false,
  inviting: false,
  hijacking: false,
  copying: false,

  canEdit: false,
  canDelete: false,
  canEmail: false,
  canInvite: false,
  canCopyInvitationLink: false,
  canHijack: false,
  canDisconnect: false,

  requestEdit: () => {},
  requestInvite: () => {},
  requestCopyInvitationLink: () => {},
  requestDelete: () => {},
  requestHijack: () => {},
  requestDisconnect: () => {},

  canCheckSyncPermission: false,
  requestCheckUserPermission: () => {},

  canSyncOwnerProfile: false,
  requestSyncOwnerProfile: () => {},
};

export default ActionRenderer;
